import ChickenTable from "../../components/ChickenTable";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { Head } from '@inertiajs/react';

export default function Annotate(
  { image, imageUuid, predictions, images, predictionUuid }:
  { image: string, imageUuid: string, predictions: Array<object>, images: Array<string>, predictionUuid: string  }
) {
  return (
    <>
      <Head title="Rooster Vision - Lookup results" />
      <Navbar />
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full px-4 ml-auto mr-auto text-center">
              <div>
                <h1 className="text-black font-semibold text-5xl mb-10">Look up a rooster</h1>
                <div className="max-w-2xl px-4 mx-auto">
                  <div className="container font-bold text-4xl text-black">
                    <ChickenTable image={image} imageUuid={imageUuid} items={predictions} images={images} predictionUuid={predictionUuid} /> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
